module.exports = __webpack_public_path__ + "img/reviews_stats1.fb8275b1.png";